import React from 'react';
import {
  FaUser,
  FaPhone,
  FaIdCard,
  FaBuilding,
  FaDoorOpen,
  FaUserCog,
  FaUserPlus,
  FaEnvelope,
  FaHashtag,
} from 'react-icons/fa';

const iconMap: Record<string, React.ReactNode> = {
  name: <FaUser />,
  surname: <FaUser />,
  phone_number: <FaPhone />,
  identification_number: <FaIdCard />,
  email: <FaEnvelope />,
  management: <FaBuilding />,
  office: <FaDoorOpen />,
  department: <FaBuilding />,
  authorization_level: <FaUserCog />,
  role: <FaUserCog />,
  number: <FaHashtag />,
  text: <FaUserPlus />,
  default: <FaUserPlus />,
};

export const getFieldIcon = (fieldKey: string): React.ReactNode => {
  return iconMap[fieldKey] || iconMap.default;
};
